import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { setAppLanguage } from '../i18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Compact 🇬🇧 EN / 🇵🇭 FIL segmented toggle for the top nav.
 * Flips the app language instantly and best-effort persists it to the
 * account (so it follows the user across devices) when logged in.
 */
const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language === 'fil' ? 'fil' : 'en');

  useEffect(() => {
    setLang(i18n.language === 'fil' ? 'fil' : 'en');
  }, [i18n.language]);

  const change = async (next) => {
    if (next === lang) return;
    setAppLanguage(next);
    setLang(next);
    if (localStorage.getItem('token')) {
      try {
        await axios.put(`${API}/settings/language`, { language: next });
      } catch (e) {
        /* non-critical: local switch already applied */
      }
    }
  };

  const btn = (code, flag, label) => (
    <button
      type="button"
      onClick={() => change(code)}
      className={`px-2 py-1 text-xs font-semibold transition flex items-center gap-1 ${
        lang === code ? 'bg-gray-900 text-white' : 'text-gray-500 hover:text-gray-800'
      }`}
      data-testid={`lang-${code}`}
      aria-pressed={lang === code}
    >
      <span aria-hidden>{flag}</span>
      <span>{label}</span>
    </button>
  );

  return (
    <div
      className={`flex items-center rounded-full border border-gray-200 overflow-hidden ${className}`}
      data-testid="language-toggle"
    >
      {btn('en', '🇬🇧', 'EN')}
      {btn('fil', '🇵🇭', 'FIL')}
    </div>
  );
};

export default LanguageToggle;
